import app from '../../scripts/app';
import template from './ad-assessment.jade';

app.directive('cianAfAdAssessment', [
  function () {
    return {
      template,
      scope: {},
      bindToController: {},
      controller(popupService, adAssessmentService) {
        'ngInject';

        this.isVisibleThanks = false;
        // Для того, чтобы не нажимали много раз
        let isProcessing = false;

        this.reportDislike = () => {
          reportAssessment(adAssessmentService.AdAssessmentCode.DISLIKE);
        };

        this.reportOk = () => {
          reportAssessment(adAssessmentService.AdAssessmentCode.OK);
        };

        this.reportLike = () => {
          reportAssessment(adAssessmentService.AdAssessmentCode.LIKE);
        };

        this.handlerPopup = () => {
          adAssessmentService.setIsVisible(false);
          this.isVisibleThanks = false;
          popupService.openPopup('adAssessment');
        };

        const sendReport = code => {
          isProcessing = true;
          adAssessmentService
            .sendAssessmentCode(code)
            .then(() => {
              if (code !== adAssessmentService.AdAssessmentCode.LIKE) {
                this.handlerPopup();
              } else {
                this.isVisibleThanks = true;
              }
            })
            .catch(() => {
              popupService.openPopup('reportMessageError');
            })
            .then(() => {
              isProcessing = false;
            });
        };

        const reportAssessment = value => {
          if (isProcessing) {
            return false;
          }
          sendReport(value);
        };
      },
      controllerAs: 'adAssessmentCtrl',
    };
  },
]);
